module.exports = __webpack_public_path__ + "static/img/how-it-work-banner.7359072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-work-banner.png
// module id = RtbZ
// module chunks = 1